const RouteEnum = {
  DefaultPlan: '/default',
  CompanyStep: '/plan/:planId/',
  LegalResponsibleStep: '/plan/:planId/legal-responsible',
  AddressStep: '/plan/:planId/address',
  SecurityStep: '/plan/:planId/security',
  SuccessStep: '/plan/:planId/success',
}

export default RouteEnum
